import en from './en'

export default {
  en
}



// WEBPACK FOOTER //
// ./src/langs/index.js